import React, { ReactNode } from "react";
import { useSelector } from "react-redux";
import { UserState } from "../../types/types";
import { Navigate } from "react-router";
import { Stack } from "@mui/material";
import { ROLES_ID } from "../../utils/roles";

type Props = {
  userHas: string;
  children: ReactNode;
};

const UserHas = ({ userHas, children }: Props) => {
  const userData = useSelector((state: UserState) => state.user.userData);
  const userRoles: number[] = userData.roles;

  return userData[userHas] ? (
    <>{children}</>
  ) : userRoles.includes(ROLES_ID.ADMIN) ? (
    <Navigate to="/" />
  ) : userRoles.includes(ROLES_ID.MARKETER) ? (
    <Navigate to="/marketer" />
  ) : (
    <Stack>NOT allowed</Stack>
  );
};

export default UserHas;
